import { createAction } from '@reduxjs/toolkit';
export const setDefinitions = createAction('definitions/setDefinitions');
